/**
 * 
 * Bắt buộc giao tiếp dữ liệu với "stores" thông qua các file trong tầng "stores/Actions"
*/
import { SInstrumentsDynamic, SInstrumentsStatic, SInstrumentsStaticStatus, SSymbolsGroup, SSymbolsGroupStatus, SSymbolsList, getInstrumentsAction, getSymbolsByIdPbTabAction, getSymbolsListAction } from '@/stores/dataManager/Actions/symbolsAction';
import { reduxVariableStatus } from '@/stores/dataStore/memoryStore/const/constIndex';
import { useAppSelector } from '@/stores/dataStore/reduxStore/hook';
/**
 * 
 * use hook maping data redux
*/
export const useSymbolsList = () => {
    try {
        const symbolsList = useAppSelector(SSymbolsList)
        return {
            symbolsList
        };
    } catch (e) {
        return {
            symbolsList: [],
        };
    }
}

export const useSymbolsListGroup = () => {
    try {
        const symbolsGroup = useAppSelector(SSymbolsGroup)
        const symbolsListStatus = useAppSelector(SSymbolsGroupStatus)
        // const symbolsList = useAppSelector(SSymbolsList)
        // console.log("useSymbolsListGroup.:", symbolsGroup, symbolsListStatus)
        return {
            symbolsGroup,
            symbolsListStatus

        };
    } catch (e) {
        return {
            symbolsGroup: [],
            symbolsListStatus: reduxVariableStatus.FAILED
        };
    }
}

export const useInstrumentsStatic = () => {
    try {
        const instrumentsStatic = useAppSelector(SInstrumentsStatic)
        const instrumentsStaticStatus = useAppSelector(SInstrumentsStaticStatus)
        return {
            instrumentsStatic,
            instrumentsStaticStatus
        };
    } catch (e) {
        return {
            instrumentsStatic: [],
            instrumentsStaticStatus: reduxVariableStatus.FAILED
        };
    }
}

export const useInstrumentsDynamic = () => {
    try {
        const instrumentsDynamic = useAppSelector(SInstrumentsDynamic)
        return {
            instrumentsDynamic,
        };
    } catch (e) {
        return {
            instrumentsDynamic: [],
        };
    }
}

/**
 * 
 * use maping function
*/

export const symbolsListManager = () => {
    const getSymbolsListManager = () => {
        try {
            return getSymbolsListAction()
        } catch (e) {
            return () => { }
        }
    }
    return { getSymbolsListManager }
}

export const onChangeTabsManager = () => {
    const getSymbolsListManager = (params: { config?: object, idPbTab: string }) => {
        try {
            // call api lấy dữ liệu theo idPbTab Active
            let _params = {
                config: {
                    pwa: true,
                    ...params.config
                },
                idPbTab: params?.idPbTab
            }
            return getInstrumentsAction(_params)
        } catch (e) {
            return () => { }
        }
    }
    /**
     * 
     */
    const getSymbolsByIdPbTabManager = (params: { idPbTab: string }) => {
        return getSymbolsByIdPbTabAction(params)
    }
    /**
    * 
    */
    return {
        getSymbolsListManager,
        getSymbolsByIdPbTabManager
    }
}


